
import React from 'react';

import { TabPanel } from '../../core';
import LayerSwitcherWithLegendPanel from './layer/LayerSwitcherWithLegendPanel';

const renderTabPanel = (props) => {
    return (
        <TabPanel key={props.name} name={props.name} iconName={props.iconName} title={props.title}>
            <LayerSwitcherWithLegendPanel
                layers={props.map.layers}
                groups={props.map.groups}
                map={props.map}
                onlyOverLayers={props.onlyOverLayers}
                moduleActions={props.mapActions}
            />
        </TabPanel>
    );
}

export default renderTabPanel;
